module.exports = __webpack_public_path__ + "img/CSS.aa784efd.png";